import { Component, OnInit } from '@angular/core';
import { RunningJarPopupComponent } from '../etl/running-jar-popup/running-jar-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { CommonService } from 'src/app/shared/services/common.service';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { AvailableServiceTsService } from './available-service.ts.service';
import { EditButton } from 'src/app/shared/common/Editbutton';
import { UserRoutingModule } from '../user-routing/user-routing.module';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';

@Component({
    selector: 'app-available-service',
    templateUrl: './available-service.component.html',
    styleUrls: ['./available-service.component.scss'],
    standalone: false
})
/**
 * Added By Abhishek t
 * 16-10-2023
 * This component handles the available services and provides functionality to edit and save them.
 */
export class AvailableServiceComponent implements OnInit {
  comapanyId=0;

  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;

  components: any;

  overlayNoRowsTemplate;

  listObjectDropDown: any = [];

  dynamicData = [];

  trnxScreenId;

  ngModelObject = [];

  ngModelObjectDivision = [];

  bootstrapColumn = 0;

  //dropDowns = [];

  retrieveObject: any = [];

  headerNameHtml = '';

  buttonName;

  tableName = '';

  tableID = '';

  agGridShow = false;

  retrieveNgModelCreation: any = [];

  screenType;

  value;

  recordsStart = 0;

  screenTypeTOrM = '';

  backgroundColorScreen = '';

  backgroundColorButton = '';

  isdisable: boolean = false;

  getData: any = [];

  userData:any=[];

  roleData:any=[];
  columnDefs2;
  buttonIdList:any = [];
  //constructor
  constructor(
    private dialog: MatDialog, private service: AvailableServiceTsService, private localStorage: LocalStorageSettingsService,
    private snackBar:MatSnackBar,private spinner:NgxUiLoaderService,private commonService:CommonService,private userRoutingModule: UserRoutingModule,private localStorageSettings: LocalStorageSettingsService
    ,private reportLinkService:ReportlinksserviceService
  ) {
    this.components = {

      buttonRenderer: EditButton,

    };

  }

  async ngOnInit() {
    /*
        Modified by: Bhor S
        Date: 29/7/25
        retrieving the data for buttonId and passing to update the permission in edit button
        */
    let screenPath = this.userRoutingModule.print(this.constructor.name);
    console.log(screenPath);
    this.reportLinkService.screenoperationspermission(screenPath,this.localStorageSettings.getSettings('UserId')).subscribe(res => {
      console.log(res);
      let responsedata: any ;
      responsedata = res;
      for (let i = 0; i <responsedata.length ; i++) {
        
       this.buttonIdList.push(responsedata[i].buttonId); // Add buttonId to the list
       }
       
       this.buttonIdList.push('screen');
       console.log('Button ID List:', this.buttonIdList);
       const buttons = document.querySelectorAll('button'); // Select all buttons in the DOM
       buttons.forEach(button => {
       const buttonId = parseInt(button.getAttribute('id'), 10); // Get the button's id
       if (!isNaN(buttonId)) { // Only process buttons with a valid numeric id
         if (!this.buttonIdList.includes(buttonId)) {
             button.setAttribute('disabled', 'true'); // Disable the button
         } else {
             button.removeAttribute('disabled'); // Enable the button
         }
       }
       });
 
     });
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },

      sortable: true,

      resizable: true,

      filter: true

    };
    
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          values: this.buttonIdList,
          edit: this.editIcon.bind(this),
        
        },
        pinned: 'center',
        lockPinned: true,
        width: 150,
      },

      {
        headerName: 'Available Service Id',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Available Service Id : ' + params.value,
        field: 'availableserviceID',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Extraction',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Extraction : ' + params.value,
        field: 'extraction',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Transform',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Transform : ' + params.value,
        field: 'transform',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Load',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Load : ' + params.value,
        field: 'loader',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      {
        headerName: 'Load To FTP',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Load To FTP : ' + params.value,
        field: 'loadtoftp',
        filter: 'agTextColumnFilter',
        width: 180,
      },
      {
        headerName: 'Validation',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Validation : ' + params.value,
        field: 'validation',
        filter: 'agTextColumnFilter',
        width: 180,
      },

      



    ];

    this.columnDefs2 = [
     
      

      {
        headerName: 'Extraction',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Extraction : ' + params.value,
        field: 'extraction',
        filter: 'agTextColumnFilter',
        width: 240,
      }, {
        headerName: 'Transform',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Transform : ' + params.value,
        field: 'transform',
        filter: 'agTextColumnFilter',
        width: 240,
      },

      {
        headerName: 'Load',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Load : ' + params.value,
        field: 'loader',
        filter: 'agTextColumnFilter',
        width: 240,
      },

      {
        headerName: 'Load To FTP',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Load To FTP : ' + params.value,
        field: 'loadtoftp',
        filter: 'agTextColumnFilter',
        width: 240,
      },
      {
        headerName: 'Validation',
        headerTooltip: 'Material Requisition Number',
        tooltipValueGetter: (params) =>
          'Validation : ' + params.value,
        field: 'validation',
        filter: 'agTextColumnFilter',
        width: 240,
      },


    ];
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");

    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.retrieveLogedInUser();

  }

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {

    this.gridAPI.exportDataAsCsv();

  }

  //pagination code
  onPaginationChanged() {

    if (this.gridAPI) {

      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();

    }

  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {

    this.gridAPI.paginationGoToPage(searchValue - 1);

  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {

    var value = this.pageSize;

    this.gridAPI.setGridOption('paginationPageSize', Number(value));

  }

  // below function is for going to next page
  async onBtNext() {

    /*this.recordsStart = this.recordsStart + 100;

    this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

    console.log(this.retrieveObject);

    if (this.retrieveObject.length == 0) {

      this.recordsStart = this.recordsStart - 100;

    }

    else {

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToNextPage();

  }

  // below function for going to previous page
  async onBtPrevious() {

    /*if (this.recordsStart > 0) {

      this.recordsStart = this.recordsStart - 100;

      this.retrieveObject = await this.trnxCommonTs.retrieveTrnx(this.tableName, this.listObjectDropDown, this.ngModelObject, this.recordsStart);

      console.log(this.retrieveObject);

      this.gridAPI.setGridOption('rowData', this.retrieveObject);

    }*/

    this.gridAPI.paginationGoToPreviousPage();

  }

  // below function for going to first page
  onBtFirst() {

    this.gridAPI.paginationGoToFirstPage();

  }

  // below function for going to last page
  onBtLast() {

    this.gridAPI.paginationGoToLastPage();

  }
  gridApiRemain;
  gridColumnAPIRemain;
  getDataRemain

  //pagination code ends

  // below function is to load the ag grid
  async onGridReady(params) {
    this.gridAPI = params.api;
    this.getData = [];
    this.gridColumnAPI = params.columnApi;

    this.retrieveAvailService();



  }
  //retrieve Assign Users Role By DnsId
  retrieveAvailService(){
   
    this.service.retrieveAvailService().subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
         
         
          for (const item of response) {
            this.isdisable=true;
            break;
            };
            
          

          this.spinner.stop();
         
          
          this.gridAPI.setGridOption('rowData', response);
        
          
        }
      }
    );
  }

  retrieveRemainService(){
    this.spinner.start();
   
    this.service.retrieveRemainService().subscribe((response) => {
      if (response.error == true) {
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });
      } else {
        console.log(response)
        this.spinner.stop();
        this.gridApiRemain.setGridOption('rowData', response); // Assuming that the data you want to set is inside the 'data' property.
      }
    });
    this.spinner.stop();
  }

 

  // Aggrid Edit function
  editIcon(e) {
    if(this.comapanyId==1){

    let rowData = e.rowData;

    console.log(rowData);

    let obj = {
      'extraction': e.rowData.extraction,
      'transform': e.rowData.transform,
      'loader': e.rowData.transform,
      'loadtoftp': e.rowData.loadtoftp,
      'buttonName': 'Update',
      'gridname':'availableService',
      'availableserviceID':e.rowData.availableserviceID,
      'validation':e.rowData.validation
    };
    let dialogRef = this.dialog.open(RunningJarPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(result=>{
      this.retrieveAvailService();
      this.retrieveRemainService();
    })}
    else{
      this.snackBar.open("You don't have access to perform this action", "OK", { duration: 5000 });
    }

  }

  

  openSaveForm(buttonName) {
    let obj = {
     
      'buttonName': 'save',
      'gridname':'availableService'
     
    };
    let dialogRef = this.dialog.open(RunningJarPopupComponent, {
      panelClass: 'custom-dialog-container-materialFulfilment',
      width: '55%',
   
      autoFocus: false,
      data: { edata: obj},
      disableClose: true,
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      this.retrieveAvailService();
      this.retrieveRemainService();


    });
  }
  retrieveLogedInUser(){
  
    var userId = localStorage.getItem('UserId');
    this.commonService.retrieveLogInUser(parseInt (userId)).subscribe(response=>
      {
        if (response.error == true) {

          this.spinner.stop();

          this.snackBar.open(response.statusMessage, "OK", { duration: 5000 });

        }
        else {
          this.comapanyId=response[0].companyid;
        
          console.log(response);
    
          console.log(this.comapanyId);
        


        }
      }
    );
  }
  async onGridReady2(params) {
    this.gridApiRemain = params.api;
    this.getDataRemain = [];
    this.gridColumnAPIRemain= params.columnApi;

    this.retrieveRemainService();



  }
  

}
